export default {
    name: 'instamapsBreadcrumbs',
    props: {
        title: { type: String },
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/breadcrumbs/breadcrumbs.js